export default __webpack_public_path__ + "static/media/choosingPerson.bdd4a690.png";